// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Image_wrapper__26xQ5","img":"Image_img__Y1QXC","skeleton":"Image_skeleton__3HG6f"};